import { isFeatureEnabled } from 'owa-feature-flags';

export default function isPersistentTaskpaneEnabled(): boolean {
    return isFeatureEnabled('addin-persistentTaskPane');
}
